import { render, staticRenderFns } from "./PICK3-game.vue?vue&type=template&id=5c226d0a"
import script from "./PICK3-game.vue?vue&type=script&lang=js"
export * from "./PICK3-game.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports